import tetris from "./tetris";
import keyboard from "./keyboard";
import output from "./output";

tetris(keyboard(output()));
